import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './MyBooks.css';

const MyBooks: React.FC = () => {
  const navigate = useNavigate();

  const books = [
    { id: 1, title: 'Mathematics Fundamentals', author: 'John Doe', progress: 45, type: '📖 Book' },
    { id: 2, title: 'English Grammar Guide', author: 'Jane Smith', progress: 100, type: '📖 Book' },
    { id: 3, title: 'Science Encyclopedia', author: 'Dr. Brown', progress: 20, type: '📖 Book' }
  ];

  return (
    <div className="my-books-page">
      <header className="my-books-header">
        <button className="back-button" onClick={() => navigate('/profile')}>
          ←
        </button>
        <h1>My Books</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="my-books-content">
        {books.map((book) => (
          <div key={book.id} className="book-card">
            <div className="book-icon">{book.type}</div>
            <div className="book-info">
              <h3 className="book-title">{book.title}</h3>
              <p className="book-author">{book.author}</p>
              <div className="book-progress">
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{ width: `${book.progress}%` }}
                  ></div>
                </div>
                <span className="progress-text">{book.progress}%</span>
              </div>
            </div>
            <button className="read-button">Read</button>
          </div>
        ))}
      </div>

      <BottomNavigation />
    </div>
  );
};

export default MyBooks;

